var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{ 'btn-primary': _vm.isOn, 'btn-secondary': !_vm.isOn},domProps:{"innerHTML":_vm._s(_vm.isOn ? '<strong>On</strong>' : 'Off')},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }